import { Dimensions, StatusBar } from 'react-native';
import { RFValue } from 'react-native-responsive-fontsize';

const dimensions = Dimensions.get('window');

const { currentHeight } = StatusBar;
const { width, height } = dimensions;

// const pixelScaler = (size: any) => RFValue(size, 680); // when release
const pixelScaler = (size: any) => RFValue(size, height);

const deviceHeight = StatusBar.currentHeight ? height - (currentHeight || 0) : dimensions.height;

const device = {
  width,
  height: deviceHeight,
};

const metrics = {
  tiny: pixelScaler(2),
  small: pixelScaler(6),
  medium: pixelScaler(10),
  large: pixelScaler(16),
  huge: pixelScaler(32),
  extraHuge: pixelScaler(62),

  smallBorderRadius: pixelScaler(4),
  borderRadius: pixelScaler(6),
  bigBorderRadius: pixelScaler(12),

  homeHeaderHeight: pixelScaler(186),
  headerBarHeight: pixelScaler(46),
  inputHeight: pixelScaler(50),

  selectSeatWidth: device.width * 0.85,
};

const buttonSize = {
  buttonNormal: pixelScaler(50),
  buttonSmall: pixelScaler(30),
};

const fontSizes = {
  // huge: pixelScaler(20),
  // large: pixelScaler(14),
  // regular: pixelScaler(12),
  // medium: pixelScaler(10),
  // small: pixelScaler(9),
  huge: pixelScaler(24),
  larger: pixelScaler(20),
  large: pixelScaler(16),
  regular: pixelScaler(14),
  medium: pixelScaler(12),
  small: pixelScaler(10),
};

const iconSize = {
  regular: pixelScaler(18),
  medium: pixelScaler(16),
  small: pixelScaler(10),
};

const shadow = (elevation: number, shadowOpacity = 0.1, width = 0) => {
  let height: number;
  let radius: number;

  switch (elevation) {
    case 1:
      height = 0.5;
      radius = 0.75;
      break;
    case 2:
      height = 0.75;
      radius = 1.5;
      break;
    default:
      height = elevation - 1;
      radius = elevation;
  }

  return {
    shadowColor: 'black',
    shadowOffset: {
      width,
      height,
    },
    shadowOpacity,
    shadowRadius: radius,
    elevation,
  };
};

export { metrics, device, pixelScaler, fontSizes, shadow, buttonSize, iconSize };
